import { render, staticRenderFns } from "./public-booking-form.vue?vue&type=template&id=0bab7b8c&scoped=true&"
import script from "./public-booking-form.ts?vue&type=script&lang=ts&"
export * from "./public-booking-form.ts?vue&type=script&lang=ts&"
import style0 from "./public-booking-form.scss?vue&type=style&index=0&id=0bab7b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bab7b8c",
  null
  
)

export default component.exports